import { mapState } from 'vuex';

import Lottie from 'vue-lottie-web';
import lottieDataCenter from './data/larkspur_Niz_final.json';
import lottieDataLeft from './data/proplus_L.json';
import lottieDataRight from './data/proplus_R.json';

import quizarticle from '@/components/quizarticle/index.vue'

export default {
    name: 'wai_employers',
    props: {},

    components: {
        quizarticle,
        Lottie
    },

    data: function() {

        return {
            loading: false,
            
            hiddenarticleshowed : false,
            lottieDataCenter,
            timeend : null,
            lottieDataLeft,
            lottieDataRight,
            lottieInstance: '',

            isRDVisible: true,
            workwidth: 0,
            members: [{
                    img: 'imt1.jpg',
                    text1: 'Sergei',
                    text2: 'Co-Founder & CEO',
                    link: 'https://www.linkedin.com/in/sergei-polevikov-7656963b/'
                },

                {
                    img: 'imt2.jpg',
                    text1: 'Daniel',
                    text2: 'Co-founder & Machine Learning Lead',
                    link: 'https://www.linkedin.com/in/daniel-satchkov-3986421/'
                },

                {
                    img: 'imt5.jpg',
                    text1: 'Carlson',
                    text2: 'Lead Medical Researcher',
                    link: 'https://www.linkedin.com/in/carlson-aruldas-3751461b6/'
                },

                {
                    img: 'imt4.jpg',
                    text1: 'Val',
                    text2: 'Back End Architect',
                    link: 'https://www.linkedin.com/in/valentin-kolesov-9a1b931/'
                },
                {
                    img: 'imt3.jpg',
                    text1: 'Max',
                    text2: 'Front End Architect',
                    link: 'https://www.linkedin.com/in/max-grishkov-20a52aa8/'
                }
            ],

            testimonials : [
                {
                    text : 'RiXtrema is by far the best product for RIAs who want to win retirement plan business. As one prospect put it ‘this is the best presentation they have ever seen’. Since we purchased the product in July we have well over 20 solid leads and some have already closed.',
                    img : 'apas.jpg',
                    name : 'Alexander Pasquale',
                    rg : 'President of the Everest Consultants, LLC'
                },

                {
                    text : 'I wanted to give a recommendation to the group at Rixtrema! We’ve worked together adding a few personalized features to the web site and the service has been outstanding. The web site has allowed me to double my prospecting efforts.',
                    img : 'greghicks.jpg',
                    name : 'Greg Hicks',
                    rg : 'CRPC® Vice President – Investments'
                },

                {
                    text : 'Our firm can not only provide excellent plan governance but the cost sayings can be truly eye opening. Builds credibility with your strategic partners and enhances referrals. Also the support has been amazing when I have questions, response is outstanding!',
                    img : 'valerib.jpg',
                    name : 'Valeri Bishop',
                    rg : 'AIF®'
                }
               /* ,
                {
                    text : '',
                    img : '',
                    name : '',
                    rg : ''
                },
                {
                    text : '',
                    img : '',
                    name : '',
                    rg : ''
                },
                {
                    text : '',
                    img : '',
                    name : '',
                    rg : ''
                }*/
            ],

            offers : {

                products : {
                    basic : {
                        name : "Pro",
                        price : '$3495',
                        priceperiod : "/ user / 12 Months"
                    },
                    pro : {
                        name : "Pro Plus",
                        price : '$6945',
                        special : "$4995",
                        priceperiod : "/ user / 12 Months",
    
                        most : true
                    },
                    platinum : {
                        name : "Platinum",
                        price : '$10000',
                        priceperiod : "/ user / 12 Months",
    
                        best : true
                    }
                },
    
                features : {
    
                    plans : {
                        text : "850,000+ plans",
                        icon  : '<i class="fas fa-globe-americas"></i>',
    
                        basic : true
                    },
    
                    executives : {
                        text : "1.2+ million plan executives with contact data at your fingertips",
                        icon : '<i class="fas fa-users"></i>',
    
                        basic : true
                    },
    
                    samepro : {
                        text : "Everything in Larkspur Executive PRO +",
                        icon : '<i class="fas fa-caret-left"></i>',
    
                        pro : true
                    },

                    campaignsprop : {
                        text : "500 simultaneous campaigns",
                        icon : '<i class="fas fa-route"></i>',
                        pro : true
                    },

                  

                    crmprop : {
                        text : "LE PRO PLUS CRM: Lead Management & Immediate Alerts for Fast Follow-up",
                        value : '$650',
                        icon : '<i class="fas fa-users"></i>',
                        pro : true,
                        b1 : 1
                    },

                    videoLeadzprop : {
                        text : "VideoLeadz: Bring your inbound marketing into 21st century with inbound video calls from prospects",
                        value : '$300',
                        icon : '<i class="fas fa-video"></i>',
                        pro : true,
                        b1 : 2
                    },
                    quizzesprop : {
                        text : "Marketing Quizzes: Lead Magnets To Attract Plan Sponsors",
                        value : '$1200',
                        icon : '<i class="far fa-question-circle"></i>',
                        pro : true,
                        b1 : 3
                    },

                    lpprop : {
                        text : "Landing Page Creator: Build custom landing pages for any audience from templates",
                        value : '$600',
                        icon : '<i class="fas fa-sticky-note"></i>',
                        pro : true,
                        b2 : 1
                    },

                    fundsscrprop : {
                        text : "FundScreener: Advanced fund rating tool to help pitch investment menus to plans",
                        value : '$1200',
                        icon : '<i class="fab fa-searchengin"></i>',
                        pro : true,
                        b2 : 2
                    },
    
                    autopro : {
                        text : "Automated email campaigns to 700k qualified plans",
                        icon : '<i class="fas fa-magic"></i>',
    
                        basic : true
                    },
    
                    campaignspro : {
                        text : "300 simultaneous campaigns",
                        icon : '<i class="fas fa-route"></i>',
    
                        basic : true
                    },
    
    
    
                    notipro : {
                        text : "Notification when decision maker opens your emails",
                        icon : '<i class="far fa-user-circle"></i>',
    
                        basic : true
                    },
    
                    descapro : {
                        text : "Expert designed email campaign available to you on day 1 of subscription",
                        value : '$2300',
                        icon : '<i class="fas fa-tasks"></i>',
    
                        basic : true
                    },
    
                    bulk : {
                        text : "Ability to create email campaigns in bulk: many plans and many emails sent at once saving you time",
                        icon : '<i class="fas fa-calendar"></i>',
                        basic : true
                    },
    
                    samept : {
                        text : "Everything in Larkspur Executive PRO & PRO PLUS +",
                        icon : '<i class="fas fa-caret-left"></i>',
    
                        platinum : true
                    },
                    campaignspt : {
                        text : "3000 simultaneous campaigns",
                        icon : '<i class="fas fa-route"></i>',
                        platinum : true
                    },
    
                    chept : {
                        text : "401kFiduciaryOptimizer - premier analytics platform for audited plans, estimates savings to the plan when they hire you",
                        value : '$4200',
                        icon : '<i class="fas fa-dollar-sign"></i>',
    
                        platinum : true
                    },
    
                    /*exclusivity : {
                        text : "Exclusivity on 500 Plans! You can choose to protect up to 500 plans, nobody emails them while your campaign is running",
                        icon : '<i class="fas fa-lock"></i>',
                        platinum : true
                    },*/
    
    
    
                }
            }
        }

    },

    mounted: function() {
        this.setworkwidth()

        var to = this.$route.query.to

        if (to){
            let elmnt = document.getElementById(to);

            setTimeout(function(){
                elmnt.scrollIntoView(true);
                window.scrollBy(0, -90)
            }, 500)
                
        }

        this.inittimeinterval()

        
    },

    created: () => {

    },

 

    watch: {
        //$route: 'getdata'
    },

    beforeRouteEnter(to, from, next) {
        next()
    },

    beforeRouteUpdate(to, from, next) {
        next()
    },

    computed: mapState({
        auth: state => state.auth,
        spoffertext : function(){

            if(this.$route.query.dt == '20200826000000'){
                return 'Special Offer for NAPA Readers'
            }

            return 'Special Offer'
        }
    }),

    methods: {
        inittimeinterval : function(){
            var EXPIRED_DATE = '20200831000000';

            var dt = this.$route.query.dt

            if (dt) EXPIRED_DATE = dt


            this.timeend = new Date(EXPIRED_DATE.slice(0, 4),
                EXPIRED_DATE.slice(4, 6),
                EXPIRED_DATE.slice(6, 8),
                EXPIRED_DATE.slice(8, 10),
                EXPIRED_DATE.slice(10, 12));

            setInterval(this.timeinterval, 1000);
        },
        timeinterval : function(){
           
            var today = new Date();
            today = Math.floor((this.timeend-today)/1000);

            var tsec=today%60; today=Math.floor(today/60); if(tsec<0)tsec='00'; else if(tsec<10) tsec='0'+tsec;
            var tmin=today%60; today=Math.floor(today/60); if(tmin<0)tmin='00'; else if(tmin<10) tmin='0'+tmin;
            var thour=today%24; today=Math.floor(today/24);if(thour<0)thour='00'; if(today<0) today='00';


            this.$refs.days.innerText = today;
            this.$refs.seconds.innerText = tsec;
            this.$refs.minutes.innerText = tmin;
            this.$refs.hours.innerText = thour;

			this.$refs.days1.innerText = today;
            this.$refs.seconds1.innerText = tsec;
            this.$refs.minutes1.innerText = tmin;
            this.$refs.hours1.innerText = thour;
        },
        hiddenarticleshow : function(){
            this.hiddenarticleshowed = !this.hiddenarticleshowed
        },
        setworkwidth: function() {

            console.log('this.$refs.videowork', this.$refs.videowork)

            if (this.$refs.videowork) {
                console.log('this.$refs.videowork.clientWidth', this.$refs.videowork.clientWidth)
                this.workwidth = this.$refs.videowork.clientWidth
            }

        },

        getLottieInstance(lottieInstance) {
            this.lottieInstance = lottieInstance;
        },
        lottiePlay() {
            this.lottieInstance && this.lottieInstance.play();
        },
        lottieRePlay() {
            this.lottieInstance && this.lottieInstance.stop();
            setTimeout(() => {
                this.lottieInstance.play();
            });
        },
        lottiePause() {
            this.lottieInstance && this.lottieInstance.pause();
        },
        lottieStop() {
            this.lottieInstance && this.lottieInstance.stop();
        },

        requestDemoVisibilityChanged(isRDVisible, entry) {
            console.log('isRDVisible',isRDVisible)
            this.isRDVisible = isRDVisible
            console.log(entry)
        },

    },
}